import type { RouteRecordRaw } from 'vue-router'
import LivestockView from '@/views/animals/LivestockView.vue'
interface RouteMeta {
  requiresAuth: boolean
  allowedRoles?: string[]
}
export const animals: Array<RouteRecordRaw & { meta: RouteMeta }> = [
  {
    path: '/supervisor/animals',
    name: 'LivestockView',
    component: LivestockView,
    meta: { requiresAuth: true, allowedRoles: ['SUPERVISOR', 'ADMIN'] },
  },
]
